// Regla multi-negocio (Ola 1): jamás un negocio piloto fijo en el código. El login recuerda el
// último negocio usado EN ESTE DISPOSITIVO como conveniencia de UX; no es autorización — el
// backend valida identidad y negocio como siempre. Nunca se guardan contraseñas ni tokens aquí.
const KEY = 'n360.ultimo-negocio';

export function readLastBusinessSlug(): string {
  try { return localStorage.getItem(KEY) ?? ''; } catch { return ''; }
}

export function saveLastBusinessSlug(slug: string): void {
  try {
    const clean = slug.trim().toLowerCase();
    if (clean) localStorage.setItem(KEY, clean); else localStorage.removeItem(KEY);
  } catch { /* almacenamiento no disponible */ }
}
